import React,{useContext ,useRef} from 'react';
import { useReactToPrint } from "react-to-print";
import { Mizania_table_print } from './mizania_table_print';
import { GlobalContext } from '../../../context/provider';
import money_rounding from '../../../utils/money_rounding';
import numberbeautify from '../../../utils/numberbeautify';
import show_million_format from '../../../utils/show_million_format';
import { Statment_of_current_table_print } from './statment_of_current_table_print';

const Statment_of_current_table = ({mizania_date, mizania, total_previous_sold, total_current_sold, total_previous_bought, total_current_bought, data}) => {
    const { initState } = useContext(GlobalContext);
        
    const printRef = useRef();

    const printFn = useReactToPrint({
        contentRef: printRef,
        documentTitle: "statment_of_current_table",
        preserveAfterPrint: true,
        print: (printIframe) =>
        new Promise(() => {
            printIframe.style.display = "none";
            printIframe.contentWindow?.print();
        }),
    });
    return (
        <div>
            <div
                style={{
                position: 'absolute',
                left: '-99999px',
                top: 0
                }}
            >
                <Statment_of_current_table_print ref={printRef} mizania_date={mizania_date} mizania={mizania} total_previous_sold={total_previous_sold} total_current_sold={total_current_sold} total_previous_bought={total_previous_bought} total_current_bought={total_current_bought} data={data}/>
            </div>
            <div className="mt-6">
                {/* Category List Card */}
                <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
                    
                    {/* Section Header */}
                    <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
                        <h2 className="text-base font-semibold text-slate-800">
                            كشف العمليات الجارية للسنة المنتهية في {mizania_date}/12/31
                        </h2>
                    </div>

                    {/* Table */}
                    <table className="w-full">
                        <thead>
                            <tr className="bg-slate-50 border-b border-slate-100">
                                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                    رقم الكشف
                                </th>
                                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                    رقم الدليل
                                </th>
                                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                    اسم الحساب
                                </th>
                                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                    السنة الحالية (دينار/الف)
                                </th>
                                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                    السنة السابقة (دينار/الف)
                                </th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-50">
                            <tr className="hover:bg-slate-50 transition-colors duration-100">
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                    421
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right underline">
                                    صافي مبيعات البضائع بغرض البيع
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(show_million_format(Number(total_current_sold)))}
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(show_million_format(Number(total_previous_sold)))}
                                </td>
                            </tr>
                            <tr className="hover:bg-slate-50 transition-colors duration-100">
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right underline">
                                    المجموع
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(show_million_format(Number(total_current_sold)))}
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(show_million_format(Number(total_previous_sold)))}
                                </td>
                            </tr>
                            <tr className="hover:bg-slate-50 transition-colors duration-100">
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right underline">
                                    المصروفات الجارية
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                            </tr>
                            {data?.map((item, index)=>(
                                <tr key={index} className="hover:bg-slate-50 transition-colors duration-100">
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                        {item?.mizania_statement_number}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                        {item?.mizania_directory_number}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {item?.expense_type_name}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {numberbeautify(show_million_format(Number(item?.total_current_expense)))}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {numberbeautify(show_million_format(Number(item?.total_previous_expense)))}
                                    </td>
                                </tr>
                            ))}
                            {mizania?.filter((item)=>item?.mizania_category=="المصروفات الجارية")?.map((item, index)=>(
                                <tr key={index} className="hover:bg-slate-50 transition-colors duration-100">
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                        {item?.mizania_statement_number}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                        {item?.mizania_directory_number}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {item?.mizania_name}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {numberbeautify(show_million_format(item?.current_amount))}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {numberbeautify(show_million_format(item?.previous_amount))}
                                    </td>
                                </tr>
                            ))}
                            <tr className="hover:bg-slate-50 transition-colors duration-100">
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                    35
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    مشتريات بضائع بغرض البيع
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(show_million_format(Number(total_current_bought)))}
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(show_million_format(Number(total_previous_bought)))}
                                </td>
                            </tr>
                            <tr className="hover:bg-slate-50 transition-colors duration-100">
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right underline">
                                    المجموع
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(show_million_format((Number(data?.reduce((acc, item) => acc + parseFloat(item?.total_current_expense || 0), 0)))+(Number(total_current_bought))+Number(mizania?.filter((item)=>item?.mizania_category=="المصروفات الجارية")?.reduce((acc, item) => acc + parseFloat(item?.current_amount || 0), 0))))}
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(show_million_format((Number(data?.reduce((acc, item) => acc + parseFloat(item?.total_previous_expense || 0), 0)))+(Number(total_previous_bought))+Number(mizania?.filter((item)=>item?.mizania_category=="المصروفات الجارية")?.reduce((acc, item) => acc + parseFloat(item?.previous_amount || 0), 0))))}
                                </td>
                            </tr>
                            <tr className="hover:bg-slate-50 transition-colors duration-100">
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    العمليات الجارية (المرحلة الاولي)
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(show_million_format((Number(total_current_sold))-Number((Number(data?.reduce((acc, item) => acc + parseFloat(item?.total_current_expense || 0), 0)))+(Number(total_current_bought))+Number(mizania?.filter((item)=>item?.mizania_category=="المصروفات الجارية")?.reduce((acc, item) => acc + parseFloat(item?.current_amount || 0), 0)))))}
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(show_million_format((Number(total_previous_sold))-Number((Number(data?.reduce((acc, item) => acc + parseFloat(item?.total_previous_expense || 0), 0)))+(Number(total_previous_bought))+Number(mizania?.filter((item)=>item?.mizania_category=="المصروفات الجارية")?.reduce((acc, item) => acc + parseFloat(item?.previous_amount || 0), 0)))))}
                                </td>
                            </tr>
                            <tr className="hover:bg-slate-50 transition-colors duration-100">
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right underline">
                                    تضاف :الايرادات التحويلية الاخرى
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                            </tr>
                            {mizania?.filter((item)=>item?.mizania_category=="تضاف :الايرادات التحويلية الاخرى")?.map((item, index)=>(
                                <tr key={index} className="hover:bg-slate-50 transition-colors duration-100">
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                        {item?.mizania_statement_number}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                        {item?.mizania_directory_number}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {item?.mizania_name}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {numberbeautify(show_million_format(item?.current_amount))}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {numberbeautify(show_million_format(item?.previous_amount))}
                                    </td>
                                </tr>
                            ))}
                            <tr className="hover:bg-slate-50 transition-colors duration-100">
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right underline">
                                    المجموع
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(show_million_format(Number(mizania?.filter((item)=>item?.mizania_category=="تضاف :الايرادات التحويلية الاخرى")?.reduce((acc, item) => acc + parseFloat(item?.current_amount || 0), 0))))}
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(show_million_format(Number(mizania?.filter((item)=>item?.mizania_category=="تضاف :الايرادات التحويلية الاخرى")?.reduce((acc, item) => acc + parseFloat(item?.previous_amount || 0), 0))))}
                                </td>
                            </tr>
                            <tr className="hover:bg-slate-50 transition-colors duration-100">
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right underline">
                                    تنزل ـ المصروفات الحويلية الاخرى
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                            </tr>
                            {mizania?.filter((item)=>item?.mizania_category=="تنزل ـ المصروفات التحويلية الاخرى")?.map((item, index)=>(
                                <tr key={index} className="hover:bg-slate-50 transition-colors duration-100">
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                        {item?.mizania_statement_number}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                        {item?.mizania_directory_number}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {item?.mizania_name}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {numberbeautify(show_million_format(item?.current_amount))}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {numberbeautify(show_million_format(item?.previous_amount))}
                                    </td>
                                </tr>
                            ))}
                            <tr className="hover:bg-slate-50 transition-colors duration-100">
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right underline">
                                    المجموع
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(show_million_format(Number(mizania?.filter((item)=>item?.mizania_category=="تنزل ـ المصروفات التحويلية الاخرى")?.reduce((acc, item) => acc + parseFloat(item?.current_amount || 0), 0))))}
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(show_million_format(Number(mizania?.filter((item)=>item?.mizania_category=="تنزل ـ المصروفات التحويلية الاخرى")?.reduce((acc, item) => acc + parseFloat(item?.previous_amount || 0), 0))))}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="mt-5 w-full">
                    <button
                        className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-3 px-4 rounded h-12 w-full"
                        onClick={() => {
                            printFn();
                        }}
                    >
                        پرینت
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Statment_of_current_table